import produce from "immer"
import { schema } from "normalizr";
import set from 'lodash/set'
import isEmpty from 'lodash/isEmpty'
import {
    LOAD_VIEW3,
    LOAD_VIEW3_SUCCESS,
    SAVE_VIEW3
} from "../constants";

// import _validateShowHide3 from './_validateShowHide3'
import { validateShowHide3 } from 'common3'


const viewNodeSchema = new schema.Entity(
    "viewNodes",
    {},
    { idAttribute: "_id" }
);
viewNodeSchema.define({ structure: [viewNodeSchema] });

const initialState = {
    loading: false,
    viewId: null,
    viewNodes : null,
    templateId: null,
    templateNodes : null,
    viewData: {}
}



const filterNodes = ({ formData, nodes, nodeId, context }) => {


    const node = nodes[nodeId]

    if (!node) {
        console.error('[portal/src/reducers/form3.js]: NO NODE FOUND! SHOULD NOT HAPPEN')
        return false
    }

    const { extra = {} } = node
    const { showHide = {},disableRule = {} } = extra;


    const { clientConditions, reset } = showHide


    // check for children
    if (node.structure) {
        // 2021-05: this was reversed. We do not know why but it caused chained showHide not to work
        // 2021-05 WAS:for (let i = node.structure.length - 1; i >= 0; i--) {
        for (let i = 0; i < node.structure.length; i++) {
            const childId = node.structure[i]
            filterNodes({ formData, nodes, nodeId: childId, context })
        }
    }

    if ((extra.showHide && !validateShowHide3({ node, nodes,node, context : {...context, formData}, clientSide: true }))) {
        nodes[nodeId].hideComponent = true
        if (reset) {
            delete formData[nodeId]
        }
        return false
    }

    const { clientConditions : disableClientConditions } = disableRule
    if ((extra.disableRule && !isEmpty(disableClientConditions) && !validateShowHide3({ node, nodes,node, context : {...context, formData}, clientSide: true, extraField: 'disableRule' }))) {
        nodes[nodeId].disableComponent = true
    } else {
        nodes[nodeId].disableComponent = false
    }


    // bottom of tree
    nodes[nodeId].hideComponent = false
    return true
}

const view3Reducer = produce((draft, action) => {

    switch (action.type) {
        case LOAD_VIEW3:
            draft.loading = true;
            break;
        case LOAD_VIEW3_SUCCESS: {
            draft.loading = false;
            draft.nodes = action.nodes;
            draft.rootId = action.rootId;
            draft.templateId = action.templateId;
            draft.viewData = {}

            filterNodes({
                formData: {}, 
                nodeId: draft.rootId, 
                nodes: draft.nodes, 
                context: {
                    // user: state.user3.user
                }
            })

            break;
        }
        case SAVE_VIEW3: {
            /**
             * Save value to viewData
             * 
             * This will save both component _id and component name (so we do not need to translate the data)
             */

            // SAVE TO NAME (if we have any in extra)
            const node = draft.nodes[action.key]

            if( node ) {
                const { extra = {} } = node;
                const { name } = extra
                if( name ) {
                     set(draft, `viewData.${name}`, action.value)
                }
            }

            // SAVE _id (always do this)            
            set(draft, `viewData.${action.key}`, action.value)
            filterNodes({
                formData: draft.viewData, nodeId: draft.rootId, nodes: draft.nodes, context: {
                }
            })
            break;
        }
        default:
            break;
            
    }
}, initialState)


export default view3Reducer;

/* Getters */

export const getView3Loading = state => {
    return state.loading
};
export const getView3Nodes = state => {
    return state.nodes
};

export const getView3Id = state => {
    return state.rootId
};

export const getView3TemplateId = state => {
    return state.templateId
};


export const getView3Data = state => {
    return state.viewData
};
